import { QADashboard } from "@/src/models/dashboard/qa-dashboard";
import { useDashboardsInternalQAStore } from "@/src/stores/dashboards/internal-qa";
import Checkbox from "primevue/checkbox";
import InputText from "primevue/inputtext";
import Select from "primevue/select";
import Textarea from "primevue/textarea";
import { Component } from "vue";

type DropdownOption = {
  label: string;
  value: string;
}

export class TableColumn {
  identifier: string;
  header: string;
  field: string;
  position: number;
  width?: string;
  permission?: string;
  defaultColumn: boolean = false;
  isFrozen: boolean = false;
  isSortable: boolean = false;
  sortField?: string;
  isVisible: boolean = true;
  editable: boolean = false;
  columnType?: string;
  options?: DropdownOption[] | string;
  style?: string;
  showClear?: boolean = true;
  placeholder?: string;
  statusIcon?: boolean = false;
  editorComponent?: Component | null;
  editorProps?: any;

  constructor({ header, field, position, width, permission, isFrozen, isSortable, sortField, isVisible, defaultColumn, identifier, editable, columnType, options, style, showClear, placeholder, statusIcon, editorComponent = null, editorProps = {} }: {
    identifier: string;
    header: string;
    field: string;
    position: number;
    width?: string;
    permission?: string;
    isVisible?: boolean;
    isFrozen?: boolean;
    isSortable?: boolean;
    sortField?: string;
    defaultColumn?: boolean;
    editable?: boolean
    columnType?: string;
    options?: DropdownOption[] | string;
    style?: string;
    showClear?: boolean;
    placeholder?: string;
    statusIcon?: boolean;
    editorComponent?: Component | null;
    editorProps?: any;
  }) {
    this.identifier = identifier;
    this.header = header;
    this.field = field;
    this.position = position;
    this.width = width;
    this.permission = permission;

    // Since it's a boolean we need to do a hard check for false
    this.isVisible = (isVisible === false) ? false : true;
    this.defaultColumn = defaultColumn || false;
    this.isFrozen = isFrozen || false;
    this.editable = editable || false;
    this.isSortable = isSortable || false;
    this.sortField = sortField;
    this.columnType = columnType;
    this.options = options;
    this.style = style;
    this.showClear = showClear;
    this.placeholder = placeholder;
    this.statusIcon = statusIcon;
    this.editorComponent = columnType ? this.getEditorComponent(columnType) : null;
    this.editorProps = Object.keys(editorProps).length > 0 ? editorProps : options ? TableColumn.getEditorProps({ columnType, options, style }) : {};
  }

  static getProcessedDashboardColumns() {
    const dashboardCheck: {
      [key: string]: number
    } = {};
      return QADashboard.DASHBOARD_COLUMNS.map((c, idx) => {
        // This check is to make sure we don't duplicate identifiers as they are used for storing preferences
        dashboardCheck[c.identifier] = (dashboardCheck[c.identifier] || 0) + 1;
        if (dashboardCheck[c.identifier] > 1) alert(`${c.identifier} is duplicated!!`);
        return new TableColumn({ ...c, position: idx });
      });
  }

  static getEditorProps(col: any) {
    const internalQAStore = useDashboardsInternalQAStore();

    switch (col.columnType) {
      case 'dropdown':
        let colOptions: any[] = []
        if (Array.isArray(col.options)) {
          colOptions = col.options
        } else if (typeof col.options === 'string' && col.options in internalQAStore) {
          const storeValue = internalQAStore[col.options]
          colOptions = Array.isArray(storeValue) ? storeValue : storeValue?.value ?? []
        }
        return { options: colOptions, optionLabel: 'label', optionValue: 'value', class: col.style, showClear: true, placeholder: 'Select...' }
      case 'checkbox':
        return { binary: true }
      default:
        return {}
    }
  }

  private getEditorComponent(type: string) {
    switch (type) {
      case 'textInput': return InputText
      case 'dropdown': return Select
      case 'checkbox': return Checkbox
      case 'textArea': return Textarea
      default:
        alert(`${type} is not valid!!`)
        return null;
    }
  }
}

